import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UpdatedMatrix from "./finalMatrix";
import "./ResultsAccordion.css";

const ResultsAccordion = ({ readings }) => {
  return (
    <>
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        &nbsp;&nbsp;&nbsp;Details
      </Typography>

      {readings.map((e) => {
        return (
          <Accordion key={e.page}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>
                <b>
                  Label {e.page}
                  {e.lpn_1d_structure?.LABEL_TYPE
                    ? ` - ${e.lpn_1d_structure.LABEL_TYPE}`
                    : ""}
                </b>
              </Typography>
              {/* Chips */}
              {e.lpn_1d_validations && (
                <Chip
                  color={e.lpn_1d_validations.status === "ERR" ? "error" : "success"}
                  icon={
                    e.lpn_1d_validations.status === "ERR" ? (
                      <ErrorIcon />
                    ) : (
                      <CheckCircleIcon />
                    )
                  }
                  label="1D Barcode"
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1 }}
                />
              )}
              {e.lpn_2d_validations && (
                <Chip
                  color={e.lpn_2d_validations.status === "ERR" ? "error" : "success"}
                  icon={
                    e.lpn_2d_validations.status === "ERR" ? (
                      <ErrorIcon />
                    ) : (
                      <CheckCircleIcon />
                    )
                  }
                  label="2D Data Matrix Code"
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1 }}
                />
              )}
              {e.ocrStatus && (
                <Chip
                  color={e.ocrStatus === "ERR" ? "error" : "success"}
                  icon={e.ocrStatus === "ERR" ? <ErrorIcon /> : <CheckCircleIcon />}
                  label="OCR"
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1 }}
                />
              )}
            </AccordionSummary>

            <AccordionDetails>
              {e.label1DNotValid && (
                <Typography>{e.label1DNotValid}</Typography>
              )}
              {e.label2DNotValid && (
                <Typography>{e.label2DNotValid}</Typography>
              )}
              {!e.label1DNotValid && !e.label2DNotValid && (
                <UpdatedMatrix errors={e} />
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

export default ResultsAccordion;
